import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Input, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertController, ModalController } from '@ionic/angular';
import { DataService } from 'src/app/services/data.service';
import { ApiService } from 'src/app/services/api/api.service';
import { VideomodalComponent } from '../../components/videomodal/videomodal.component';

@Component({
    selector: 'app-smblockvideo',
    templateUrl: './smblockvideo.component.html',
    styleUrls: ['./smblockvideo.component.scss'],
    standalone: false
})
export class SmblockvideoComponent implements OnInit {

  @Input() b: any;
  @Input() color: any = 'green';
  public basepath = '';

  private api = inject(ApiService);

  ionViewWillEnter() {
    this.basepath = this.api.getMediaBase();
  }
  constructor(
    public data: DataService,
    public router: Router,
    public http: HttpClient,
    public alertController: AlertController,
    public route: ActivatedRoute,
    public modalController: ModalController
  ) { }

  ngOnInit() {
    this.basepath = this.api.getMediaBase();
  }

  async selectVideo(video){
    let that = this
    const modal = await this.modalController.create({
      component: VideomodalComponent,
      animated: true,
      cssClass: 'exercise-modal-shell',
      htmlAttributes: { 'aria-label': 'Video: ' + (video?.title || '') },
      componentProps: {
        video: video,
        basepath: that.api.getMediaBase()
      }
    });

    let payload = {
      token: this.data.token,
      title: 'Open video ' + video.title,
      pathway_id: that.data.pathway ? that.data.pathway.id : '',
      condition: (that.data.pathway && that.data.pathway.condition) ? that.data.pathway.condition.id : ''
    };
    void this.data.apiPost('userappnav', payload);
    return await modal.present();
  }

  videothumbpath(video){
    return encodeURI(this.api.mediaUrl(video.thumb));
  }

  mediaUrl(path: string): string {
    return this.api.mediaUrl(path);
  }

  safeURL(item) {
    return encodeURI(item);
  }
}

